import { Injectable } from '@angular/core';
import { ThreeDKeys } from 'src/app/core/constants/3D/3d-keys';
import { Event, Object3D } from 'three';
import { MapsService } from '../../simulation/objects/maps/maps.service';

@Injectable({
  providedIn: 'root',
})
export class ThreeJsHelperService {
  private static readonly regExp = /\[(.+)\]\.(.+)/;

  constructor(private mapService: MapsService) {}

  helper = 1;
  public getSimulationObjectByThreeJsObject(sceneObject: Object3D<Event>): any {
    const objectName = this.getParentName(sceneObject);
    const objetoSimulation = this.mapService.getObjectById(
      this.getIdByThreeJsObjectName(objectName),
    );
    return objetoSimulation;
  }

  public getObjectType(sceneObject: Object3D<Event>): string {
    const parentName = this.getParentName(sceneObject);
    const id: number = this.getIdByThreeJsObjectName(parentName);
    if (id === null) {
      return null;
    }

    return this.mapService.getTypeById(id);
  }

  public getParent(sceneObject: Object3D<Event>): Object3D<Event> {
    if (sceneObject.parent.type !== ThreeDKeys.SCENE) {
      return this.getParent(sceneObject.parent);
    }
    return sceneObject;
  }

  private getParentName(sceneObject: Object3D<Event>): string {
    if (sceneObject.parent.type !== ThreeDKeys.SCENE) {
      return this.getParentName(sceneObject.parent);
    }
    return sceneObject.name;
  }

  private getIdByThreeJsObjectName(objectName: string): number {
    if (!ThreeJsHelperService.regExp.test(objectName)) {
      return null;
    }

    let id: number;
    try {
      id = Number.parseInt(ThreeJsHelperService.regExp.exec(objectName)[2].replace('.', ''), 10);
    } catch {
      id = null;
    }

    return id;
  }
}
